export const NO_PROCESS = 'NO_PROCESS';

const noProcessL1 = {
  uuid: NO_PROCESS,
  id: NO_PROCESS,
  name: 'No process',
  parent_id: null,
  color: 'GREY_LIGHT',
};

export default function resolveActivityProcess(activity, library) {
  const libraryActivity = library?.activities?.mapped?.get(
    activity?.library_uuid
  );
  const processId = libraryActivity?.process_id;

  if (!processId) {
    return { l1: noProcessL1, l2: null };
  }

  const process = library?.processes?.mapped?.get(processId);

  if (!process) {
    return { l1: null, l2: null };
  }

  if (process.parent_id) {
    const l1 = library?.processes?.l1?.get(process.parent_id);
    return { l1: l1 || noProcessL1, l2: process };
  }

  return { l1: process, l2: process };
}
